"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrderSummaryFVS = void 0;
const RQ = __importStar(require("react-query"));
const utils_1 = require("../../utils");
const errors_1 = require("../../errors/errors");
const ZAlert_1 = require("../ZAlert/ZAlert");
const react_1 = __importDefault(require("react"));
const lodash_1 = __importDefault(require("lodash"));
const queryConfig = {
    suspense: false,
    staleTime: utils_1.CacheTimes.TwentyFourHours
};
exports.useOrderSummaryFVS = (fetch) => {
    const { apiClient } = react_1.default.useContext(utils_1.AppContext);
    const { issueAlert } = ZAlert_1.useAlerts();
    const { appNameAbbreviation } = utils_1.useApplicationName();
    const fetchOrderSummaryFVS = fetch
        ? () => apiClient
            .get(`FieldVisibilitySettings`, {
            params: {
                $top: "10000",
                $filter: `Platform eq ${appNameAbbreviation} and startswith(SectionName, 'OrderSummary')`
            }
        })
            .then(response => {
            const results = response.data.d.results;
            const groups = lodash_1.default.groupBy(results, fvs => fvs.SectionName);
            return {
                OrderSummaryCompany: groups.OrderSummaryCompany || [],
                OrderSummaryCustomer: groups.OrderSummaryCustomer || [],
                OrderSummarySite: groups.OrderSummarySite || [],
                OrderSummaryOrder: groups.OrderSummaryOrder || [],
                OrderSummaryAppointment: groups.OrderSummaryAppointment || [],
                OrderSummaryOrderSegment: groups.OrderSummaryOrderSegment || [],
                OrderSummaryOrderLine: groups.OrderSummaryOrderLine || []
            };
        })
            .catch(error => {
            errors_1.displayAndLogErrorWithMessage(error, "OrderSummaryFVSCannotGet", issueAlert);
            return Promise.resolve({ Error: true });
        })
        : () => {
            return Promise.resolve(null);
        };
    const { data, isFetching } = RQ.useQuery(["OrderSummaryFVS", { fetch }], fetchOrderSummaryFVS, queryConfig);
    return {
        orderSummaryFVS: data,
        pending: isFetching
    };
};
//# sourceMappingURL=useOrderSummaryFVS.js.map